export function getPostMessageTemplateSelectDataItems(response) {
  return response?.data?.objects
}
